import { useEffect, useState } from "react";
import axios from "axios";

let cache = null;
let pending = null;

export function refreshSiteImages() { cache = null; pending = null; }

export function useSiteImage(slot, fallback) {
  const [images, setImages] = useState(cache || {});
  useEffect(() => {
    if (cache) { setImages(cache); return; }
    pending = pending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/site-images`).then((r) => { cache = r.data || {}; return cache; }).catch(() => ({}));
    let alive = true;
    pending.then((d) => { if (alive) setImages(d); });
    return () => { alive = false; };
  }, []);
  return images[slot] || fallback;
}

let textCache = null;
let textPending = null;
export function refreshSiteText() { textCache = null; textPending = null; }

export function useSiteText() {
  const [text, setText] = useState(textCache || {});
  useEffect(() => {
    if (textCache) { setText(textCache); return; }
    textPending = textPending || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/site-text`).then((r) => { textCache = r.data || {}; return textCache; }).catch(() => ({}));
    let alive = true;
    textPending.then((d) => { if (alive) setText(d); });
    return () => { alive = false; };
  }, []);
  return (key, fallback) => text[key] || fallback;
}
